// store/modules/box/actions.js
import BoxApi from "../../../api/modules/BoxApi";
import util from '../../../util'

export const searchBoxes = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    return await BoxApi.searchBoxes(context, data);
  } catch (error) {
    console.error("Error al buscar cajas:", error);
    throw error;
  }
};

export const getById = async ({ commit }, payload) => {
  return BoxApi.getBoxById(payload.context, payload.id);
};

export const createBox = async ({commit}, payload) => {
  try {
    const {context, box} = payload;
    return await BoxApi.saveBox(context, { box });
  } catch (e) {
    console.error("Error al crear caja:", e);
    throw e;
  }
};

export const updateBox = async ({commit}, payload) => {
  try {
    const {context, box} = payload;
    return await BoxApi.editBox(context, { box });
  } catch (e) {
    console.error("Error al editar caja:", e);
    throw e;
  }
};

export const bulkUploadBoxes = async ({ commit }, { context, payload }) => {
  try {
    return await BoxApi.bulkUploadBoxes(context, payload);
  } catch (e) {
    console.error("Error en carga masiva:", e);
    throw e;
  }
};

export const loadLatestBoxes = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios
      .get(`api/box/${payload.idClient}/latest/${payload.codeRange}`, { headers })
      .then(response => resolve(response.data))
      .catch(error => {
        if (error.response) {
          util.showDialogError(payload.context, 'Ocurrió un error al cargar las cajitas.')
          reject(error.response)
        } else {
          reject(error)
        }
      });
  });
};

export const searchAvailableBoxes = async ({commit}, payload) => {
  try {
    const {context, filters} = payload;
    return await BoxApi.searchAvailableBoxes(context, filters);
  } catch (e) {
    console.error("Error al buscar cajas disponibles:", e);
    throw e;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/box/actions.js